import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { USER_SIGN_UP_VERIFY } from '../../store/user/user-types.store';
import { AUTHORIZATION_MODULE_NAMESPACE, AUTHORIZATION_VERIFY_EMAIL } from '../../store/authorization';
import VueRouter from 'vue-router';

const AuthorizationStore = namespace(AUTHORIZATION_MODULE_NAMESPACE);

@Component
class Container extends Vue {


  dtError: any
  dtInfo: any
  dtIsValid: boolean;
  dtIsLoading: boolean;
  /**
   *
   */
  constructor() {
    super();
    this.dtIsValid = false;
    this.dtIsLoading = false;
    this.dtError = null;
    this.dtInfo = null;
  }


  @AuthorizationStore.Action(AUTHORIZATION_VERIFY_EMAIL)
  storeVerifyEmail: (payload: { token: string, router: VueRouter }) => Promise<void>

  get lblSetting() {
    return {
      ...require('@/locales/user').default
    }
  }

  mounted() {
    const { token } = this.$route.query;
    if (token) {
      this.dtIsLoading = true;
      this.storeVerifyEmail({ token: token, router: this.$router })
        .then(res => {
          this.dtIsLoading = false;
          this.dtInfo = res;
          this.dtIsValid = true;
          this.dtError = null
        })
        .catch(err => {
          this.dtIsLoading = false;
          this.dtIsValid = false;
          this.dtError = err
        })
    }
  }
  handleGotoProfile() {
    location.href = this.config.route;
  }

  get config() {
    const token = localStorage.getItem('token');
    if (token) {
      return {
        label: 'LBL_PROFILE',
        route: '/profile'
      };
    } else {
      return {
        label: 'BTN_LOGIN',
        route: '/'
      }
    }


  }
  get buttonLocalization() {
    const token = localStorage.getItem('token');
    if (token) {
      return 'LBL_PROFILE';
    } else {
      return 'BTN_LOGIN'
    }
  }
}

export default Container;


// WEBPACK FOOTER //
// ./src/containers/change-email-verification/index.ts